import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { AppRoutingModule } from './app-routing.module';
import { SharedModule } from './shared/shared.module';
import { AuthenticationModule } from './authentication/authentication.module';
import { InstantAnalysisModule } from './instant-analysis/instant-analysis.module';
import { HistoryAnalysisModule } from './history-analysis/history-analysis.module';


import { AppComponent } from './app.component';
import { MainmenuComponent } from './mainmenu/mainmenu.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { AddProjectDialogComponent } from './dashboard/add-project-dialog/add-project-dialog.component';
import { SaveAnalysisDialogComponent } from './mainmenu/save-analysis-dialog/save-analysis-dialog.component';
import { RemoveDialogComponent } from './dashboard/remove-dialog/remove-dialog.component';
import { SocketIoModule, SocketIoConfig } from 'ngx-socket-io';
import { RoutesmapComponent } from './routes/routesmap/routesmap.component';
import { FileUploaderComponent } from './dashboard/file-uploader/file-uploader.component';
import { MissingDataComponent } from './dashboard/missing-data/missing-data.component';
import { environment } from 'src/environments/environment';
import { LandingPageModule } from './landing-page/landing-page.module';
import { RainFileUploaderComponent } from './dashboard/rain-file-uploader/rain-file-uploader.component';
import { RainJobsTableComponent } from './dashboard/rain-jobs-table/rain-jobs-table.component';
import { EventJobsTableComponent } from './dashboard/event-jobs-table/event-jobs-table.component';


/**
 * Módulo principal da aplicação web
 */
@NgModule({
  declarations: [
    AppComponent,
    MainmenuComponent,
    DashboardComponent,
    AddProjectDialogComponent,
    // SaveAnalysisDialogComponent,
    RemoveDialogComponent,
    RoutesmapComponent,
    FileUploaderComponent,
    RainFileUploaderComponent,
    MissingDataComponent,
    RainJobsTableComponent,
    EventJobsTableComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,
    SharedModule,
    AuthenticationModule,
    InstantAnalysisModule,
    HistoryAnalysisModule,
    LandingPageModule,
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
